module.exports = __webpack_public_path__ + "img/yey.db43479a.png";